module.exports = fox._r("images/search-hover.png", __webpack_public_path__ + "images/search-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/search-hover.png
// module id = 1102
// module chunks = 4